var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from "./http-api-request.js";
export function loadBooks(query, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let request = new HttpBooksApiV5Request('', config);
        if (query) {
            request.addParam('query', query);
        }
        let response = yield request.fetch();
        if (response.data == null) {
            return [];
        }
        let bookListPlain = response.data;
        let booksJson = bookListPlain.items;
        if (booksJson == null) {
            return [];
        }
        return booksJson;
    });
}
export function loadBook(bookId, loadAccounts, loadGroups, config) {
    return __awaiter(this, void 0, void 0, function* () {
        if (bookId == null) {
            throw new Error("Book id null!");
        }
        loadAccounts = loadAccounts || false;
        loadGroups = loadGroups || false;
        let response = yield new HttpBooksApiV5Request(bookId, config).addParam('loadAccounts', loadAccounts).addParam('loadGroups', loadGroups).fetch();
        return response.data;
    });
}
export function createBook(book, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpBooksApiV5Request('', config).setMethod('POST').setPayload(book).fetch();
        return response.data;
    });
}
export function updateBook(bookId, book, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}`, config).setMethod('PUT').setPayload(book).fetch();
        return response.data;
    });
}
export function audit(bookId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        new HttpBooksApiV5Request(`${bookId}/audit`, config).setMethod('PATCH').fetch();
    });
}
export function getApps(bookId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        let response = yield new HttpBooksApiV5Request(`${bookId}/apps`, config).setMethod('GET').fetch();
        return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function copyBook(bookId, name, copyTransactions, fromDate, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const request = new HttpBooksApiV5Request(`${bookId}/copy`, config).setMethod('POST').addParam('name', name);
        if (copyTransactions) {
            request.addParam('copyTransactions', copyTransactions);
            if (fromDate) {
                request.addParam('fromDate', fromDate);
            }
        }
        const response = yield request.fetch();
        return response.data;
    });
}
export function deleteBook(bookId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield new HttpBooksApiV5Request(`${bookId}`, config).setMethod('DELETE').fetch();
        return response.data;
    });
}
//# sourceMappingURL=book-service.js.map